import React, { useState } from "react"
import { CHANGE_PASSWORD } from "graphql/auth.graphql.gql"
import useErrors from "hooks/useErrors"
import { changePassword } from "models/login.model"
import CustomDialog from "components/Atoms/CustomDialog"
import StringInput from "components/Atoms/StringInput"
import ButtonMutation from "components/Molecules/ButtonMutation"
import FormController from "components/Molecules/FormController"
import AppToaster from "utils/AppToaster"

function ChangePasswordModal({ isOpen, onClose }) {
  const [passwordDetails, setPassword] = useState({
    password: "",
    passwordConfirmation: "",
  })

  const [{ details, latest }] = useErrors({
    schema: changePassword,
    state: passwordDetails,
  })

  function handleChange(path, value) {
    setPassword(prevDetails => ({
      ...prevDetails,
      [path]: value,
    }))
  }
  return (
    <CustomDialog
      light
      icon="lock"
      title="Change Password"
      isOpen={isOpen}
      onClose={onClose}
      footerRightButton={
        <ButtonMutation
          mutation={CHANGE_PASSWORD}
          variables={{ newPassword: passwordDetails.password }}
          onCompleted={() => {
            AppToaster.show({
              message: "Password changed successfully",
              intent: "success",
              icon: "tick",
            })
            setPassword({
              password: "",
              passwordConfirmation: "",
            })
            onClose()
          }}
          onError={() => {
            AppToaster.show({
              message: "Unable to change the password",
              icon: "cross",
              intent: "danger",
            })
          }}
          validate={() => {
            if (latest) {
              AppToaster.show({
                message: latest,
                intent: "danger",
                icon: "cross",
              })
              return false
            }
            return true
          }}
          icon="endorsed"
          text="Submit"
        />
      }
    >
      <FormController
        errors={details}
        source={passwordDetails}
        onChange={handleChange}
      >
        <StringInput
          className="mb-6"
          type="password"
          label="Password"
          path="password"
        />
        <StringInput
          type="password"
          label="Confirm Password"
          path="passwordConfirmation"
        />
      </FormController>
    </CustomDialog>
  )
}
export default ChangePasswordModal
